import React, { FC, useCallback } from 'react';

import { TControlDirection, TControlSize } from '../baseControlsData';

import { Label } from './styled';

export interface IRadioProps {
    size?: TControlSize,
    id?: string,
    name?: string,
    value?: string,
    checked?: boolean,
    disabled?: boolean,
    required?: boolean,
    onChange?: (value: string, event?: React.ChangeEvent<HTMLInputElement>) => void,
    className?: string,
    direction?: TControlDirection,
    [key: string]: unknown,
}

const BaseRadio: FC<IRadioProps> = ({
    size = 'XS',
    id,
    name = '',
    value = '',
    checked,
    disabled = false,
    required,
    children,
    onChange,
    className,
    direction = 'left',
    ...props
}) => {
    const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            onChange && onChange(event.target.value, event);
        }
    }, [disabled, onChange]);

    return (
        <Label
            size={size}
            disabled={disabled}
            withLabel={!!children}
            className={className}
            direction={direction}
            {...props}
        >
            <input
                type='radio'
                id={id}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                required={required}
                onChange={onChangeHandler}
            />
            {children}
        </Label>
    );
};

export default BaseRadio;
